import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "max-h-screen h-screen flex flex-col"
};
const _hoisted_2 = {
  class: "border-b"
};
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center p-1 border-b"
};
const _hoisted_4 = {
  class: "grow"
};
const _hoisted_5 = {
  class: "py-2 flex-center flex-col"
};
const _hoisted_6 = {
  class: "font-bold text-slate-600"
};
const _hoisted_7 = {
  key: 0,
  class: "text-slate-500 text-sm font-medium"
};
const _hoisted_8 = {
  key: 2,
  class: "border-t p-4 flex-center"
};
const _hoisted_9 = {
  key: 3
};
import InGameActionBar from '@/modules/vue/components/InGameActionBar.vue';
import Tabbar from "@/modules/vue/components/Tabbar.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultInGameLayout',
  props: {
    hideActionBar: {
      type: Boolean
    },
    hideTabbar: {
      type: Boolean
    },
    hideSubmenu: {
      type: Boolean
    },
    hideHeader: {
      type: Boolean
    },
    hideFooter: {
      type: Boolean
    },
    contentClasses: null,
    back: {
      type: Boolean
    },
    noContentPadding: {
      type: Boolean
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    const onClickBack = () => router.back();
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!__props.hideHeader ? _renderSlot(_ctx.$slots, "header", {
        key: 0
      }, () => [_createElementVNode("div", _hoisted_2, [!__props.hideActionBar ? (_openBlock(), _createBlock(InGameActionBar, {
        key: 0
      })) : _createCommentVNode("", true)])]) : _createCommentVNode("", true), _ctx.$slots.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, [__props.back ? (_openBlock(), _createBlock(_component_NButton, {
        key: 0,
        text: "",
        onClick: onClickBack
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.ChevronLeftFilled
        }, null, 8, ["icon"])]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "title")]), _ctx.$slots.subtitle ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_renderSlot(_ctx.$slots, "subtitle")])) : _createCommentVNode("", true)])]), __props.back ? (_openBlock(), _createBlock(_component_NButton, {
        key: 1,
        text: "",
        class: "invisible"
      }, {
        default: _withCtx(() => [_createVNode(Icon, {
          icon: _ctx.IconEnum.ChevronLeftFilled
        }, null, 8, ["icon"])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", {
        id: "layout-body",
        class: _normalizeClass(["grow overflow-y-auto flex-1 max-h-screen h-screen flex flex-col", __props.contentClasses])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["flex flex-col relative grow", {
          'px-2': !__props.noContentPadding
        }])
      }, [_renderSlot(_ctx.$slots, "default")], 2)], 2), _ctx.$slots.footerButtons ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_renderSlot(_ctx.$slots, "footerButtons")])) : _createCommentVNode("", true), !__props.hideFooter ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_renderSlot(_ctx.$slots, "pagination"), !__props.hideSubmenu ? _renderSlot(_ctx.$slots, "submenu", {
        key: 0,
        route: _ctx.$route
      }) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "footer", {}, () => [!__props.hideTabbar ? (_openBlock(), _createBlock(Tabbar, {
        key: 0
      }, {
        actionButton: _withCtx(() => [_renderSlot(_ctx.$slots, "actionButton")]),
        _: 3
      })) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
    };
  }
});